module.exports = __webpack_public_path__ + "static/img/jdFilmLogo.8163de61.png";